// extracted by mini-css-extract-plugin
export default {"player":"_2x_fppjR0j59vt0xMyVXGE","flip":"_3yLd1fr5v1GR5wAb9n7IKI","handoffMode":"_1JhTcKi2oYXA9GORVwxB8G bg-snow--d"};